import { kbEventTypes } from 'events/knowledgeBase';
import initialState from 'reducers/initialStates/knowledgeBase';

export default function knowledgeBaseReducer(state = initialState, action) {
  switch (action.type) {
    case kbEventTypes.ANSWER_FETCH_SUCCESS:
      return handleAnswersFetchSuccess(state, action);

    case kbEventTypes.ANSWER_UPDATE_SEARCH_RESULTS:
      return handleUpdatedSearchResults(state, action);

    case kbEventTypes.ANSWER_UPDATE_SELECTED_ANSWER:
      return handleUpdatedSelectedAnswer(state, action);

    case kbEventTypes.ANSWER_CLEAR_SEARCH_RESULTS:
      return handleClearSearchResults(state);

    default:
      return state;
  }
}

function handleAnswersFetchSuccess(state, action) {
  return {
    ...state,
    data: action.payload.answers,
    suggestedAnswerIds: action.payload.suggestedAnswerIds,
    searchResultAnswerIds: [],
    selectedResultAnswerId: '',
  };
}

function handleUpdatedSearchResults(state, action) {
  return {
    ...state,
    searchResultAnswerIds: action.payload.searchResultAnswerIds,
  };
}

function handleUpdatedSelectedAnswer(state, action) {
  return {
    ...state,
    selectedResultAnswerId: action.payload.selectedResultAnswerId,
  };
}

function handleClearSearchResults(state) {
  return {
    ...state,
    searchResultAnswerIds: [],
  };
}
